<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment">

        <form class="ui form">
          <div class="fields">
            <div class="two wide field">
              <label class="form-label">Emite Laudo</label>
              <span v-if="isObject(quotation.isIssueReport)">Antes: {{ quotation.isIssueReport.__old ? 'Sim' : 'Não' }}</span>
              <p v-if="isObject(quotation.isIssueReport)"></p>
              <span>{{ isObject(quotation.isIssueReport) ? quotation.isIssueReport.__new ? 'Sim' : 'Não' : quotation.isIssueReport ? 'Sim' : 'Não' }}</span>
            </div>           
            <div class="two wide field">
              <label class="form-label">Aceita Pallets</label>
              <span v-if="isObject(quotation.isPallets)">{{ quotation.isPallets.__old ? 'Sim' : 'Não' }}</span>
              <p v-if="isObject(quotation.isPallets)"></p>
              <span>{{ isObject(quotation.isPallets) ? quotation.isPallets.__new ? 'Sim' : 'Não' : quotation.isPallets ? 'Sim' : 'Não' }}</span>
            </div>
            <div class="two wide field">
              <label class="form-label">Aceita Fat. Parcial</label>
              <span v-if="isObject(quotation.isPartialBilling)">{{ quotation.isPartialBilling.__old ? 'Sim' : 'Não' }}</span>
              <p v-if="isObject(quotation.isPartialBilling)"></p>
              <span>{{ isObject(quotation.isPartialBilling) ? quotation.isPartialBilling.__new ? 'Sim' : 'Não' : quotation.isPartialBilling ? 'Sim' : 'Não' }}</span>
            </div>                                  
            <div class="ten wide field">
              <label class="form-label">Pedido do Cliente</label>
              <span v-if="isObject(quotation.customerSalesOrder)">{{ quotation.customerSalesOrder.__old }}</span>
              <p v-if="isObject(quotation.customerSalesOrder)"></p>
              <span>{{ isObject(quotation.customerSalesOrder) ? quotation.customerSalesOrder.__new : quotation.customerSalesOrder }}</span>
            </div>                                  
          </div> 
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">Obs. Transportadora</label>
              <span v-if="isObject(quotation.shippingMessage)">{{ quotation.shippingMessage.__old }}</span>
              <p v-if="isObject(quotation.shippingMessage)"></p>
              <span>{{ isObject(quotation.shippingMessage) ? quotation.shippingMessage.__new : quotation.shippingMessage }}</span>
            </div>                               
            <div class="eight wide field">
              <label class="form-label">Mensagem Nota Fiscal</label>
              <span v-if="isObject(quotation.invoiceMessage)">{{ quotation.invoiceMessage.__old }}</span>
              <p v-if="isObject(quotation.invoiceMessage)"></p>
              <span>{{ isObject(quotation.invoiceMessage) ? quotation.invoiceMessage.__new : quotation.invoiceMessage }}</span>
            </div>         
          </div>
        </form>

      </div>

    </div>

  </div>

</template>

<script>
  export default {
    props: ["quotation"],
    methods: {
      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    }  
  }
</script>

